export default {
  title: "Распространение карт RC",
  unavailablePage: "Страница недоступна",
  entityOnModeration: "Ваше юрлицо находится на модерации",
  buyTariffToGetAccess:
    "Чтобы получить доступ к странице, необходимо приобрести тариф",
  createShopToGetAccess:
    "Создайте торговую точку, чтобы получить доступ к странице и QR-код для приглашения новых пользователей",

  inviteClients: "Пригласить клиентов",

  branding: {
    title: "Брендирование промоматериалов",
    descriptions: [
      "Используйте больше каналов привлечения — с брендированными промоматериалами Русского цифрового бизнеса! Применяйте все возможности, чтобы постоянные клиенты приходили снова, а количество новых росло!",
      "Повышайте интерес к вашей компании с помощью ярких стикеров и презентабельных тейбл-тентов! На них — информация о клиентском сервисе, QR-коды для регистрации и горячая выгода от покупок с RC PAY для ваших клиентов!",
      "Покажите, что вы — участник программы лояльности и станьте заметными среди тех, кто тоже ей пользуется! Привлеките новых клиентов скидками и выгодными акциями!",
    ],
    promoLink: "Ссылка на промоматериалы",
    downloadInstruction: "Скачать инструкцию",
  },

  mainInfo: "Основная информация",

  faq: [
    {
      title: "Размещение",
      text: "Мы настоятельно рекомендуем разместить тейбл-тент  с QR-кодом и надписью «Скачай бонусную карту! Накапливай бонусные баллы и получай особые условия на покупку» рядом с кассой или местом, где ваши покупатели осуществляют расчет. Например, на столиках в кафе, в зоне ожидания рядом с кассой в магазине, или в другом месте таким образом, чтобы ваши клиенты гарантировано увидели эту информацию.",
    },
    {
      title: "Получение карты через RC KASSA",
      text: 'Используйте приложение RC KASSA для отображения вашего QR-кода: для этого нажмите на три черных точки в правом верхнем углу и выберите "Открыть QR-код". Предложите клиенту отсканировать код мобильным телефоном.',
    },
    {
      title: "Работа с сотрудниками",
      text: "Мировой опыт показывает, что сотрудники зачастую бойкотируют внедрение программ лояльности. Это относится не только к устаревшим пластиковым, но и к цифровым решениям, таким как RC Group. Многим сотрудникам может казаться, что, рассказывая клиентам о программе лояльности, они уменьшают выручку организации. Такое утверждение является заблуждением. Чем выше распространение программы лояльности, тем выше средний чек, частота покупок и лояльность к бренду. Более того, высокое распространение программы позволяет уменьшить затраты бизнеса на СМС и другие рассылки и лучше узнавать собственных клиентов.",
    },
  ],
};
